import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { MapIcon, EyeOffIcon, SparklesIcon, CpuIcon, CalculatorIcon, RocketIcon } from 'lucide-react';
export function BenefitsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const benefits = [{
    icon: MapIcon,
    title: 'Anonymous Asset Blueprint',
    description: 'The complete roadmap to building faceless YouTube channels that generate passive income.'
  }, {
    icon: EyeOffIcon,
    title: '0% Face Framework',
    description: 'Step-by-step system to create engaging content without ever appearing on camera.'
  }, {
    icon: SparklesIcon,
    title: 'H.A.L.O. Retention Formula',
    description: 'Hook-Attention-Loop-Outcome system to keep viewers watching until the end.'
  }, {
    icon: CpuIcon,
    title: 'AI Creative Stack',
    description: 'The exact AI tools and prompts to generate scripts, visuals, and voiceovers.'
  }, {
    icon: CalculatorIcon,
    title: '3-Variable Profit Rule',
    description: 'Simple formula to identify niches that will actually make money.'
  }, {
    icon: RocketIcon,
    title: '7-Day Launch Plan',
    description: 'Day-by-day action plan to get your first video live in one week.'
  }];
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-secondary" data-id="element-12">
      <div className="max-w-6xl mx-auto" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-15">
            Everything You Get <span className="text-accent-green" data-id="element-16">Inside</span>
          </h2>
          <p className="text-text-muted text-lg max-w-2xl mx-auto" data-id="element-17">
            A complete system designed to take you from zero to your first
            faceless video in 7 days.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={benefit.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card rounded-xl p-6 relative overflow-hidden group" data-id="element-19">
              {/* Glow Effect on Hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-accent-green/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-20" />

              <div className="relative" data-id="element-21">
                <div className="flex items-center justify-between mb-4" data-id="element-22">
                  <div className="w-12 h-12 rounded-xl bg-accent-green/10 flex items-center justify-center" data-id="element-23">
                    <benefit.icon className="w-6 h-6 text-accent-green" data-id="element-24" />
                  </div>
                </div>

                <h3 className="text-lg font-bold text-white mb-2" data-id="element-25">
                  {benefit.title}
                </h3>
                <p className="text-text-muted text-sm leading-relaxed" data-id="element-26">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}